import React from 'react';
import Header from '../components/Header';
import HeroSectionImproved from '../components/HeroSectionImproved';
import Marquee from '../components/Marquee';
import TrustSection from '../components/TrustSection';
import AboutSection from '../components/AboutSection';
import ServicesSectionImproved from '../components/ServicesSectionImproved';
import PricingSection from '../components/PricingSection';
import BeforeAfterSection from '../components/BeforeAfterSection';
import TestimonialsSectionImproved from '../components/TestimonialsSectionImproved';
import VideoSection from '../components/VideoSection';
import GallerySectionImproved from '../components/GallerySectionImproved';
import ContactSectionImproved from '../components/ContactSectionImproved';
import FooterImproved from '../components/FooterImproved';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <HeroSectionImproved />
      <Marquee />
      <TrustSection />
      <AboutSection />
      <ServicesSectionImproved />
      <PricingSection />
      <BeforeAfterSection />
      <TestimonialsSectionImproved />
      <VideoSection />
      <GallerySectionImproved />
      <ContactSectionImproved />
      <FooterImproved />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;